import { h, type Component } from 'vue'
import type { IconSet, IconProps } from 'vuetify'
import radioCheckedIcon from '@/atoms/icons/RadioCheckedIcon.vue'
import clear20 from '@/atoms/icons/Clear20Icon.vue'
import upload from '@/atoms/icons/UploadIcon.vue'
import patientList from '@/atoms/icons/PatientListIcon.vue'
import tableRows from '@/atoms/icons/TableRows.vue'
import deleteIcon from '@/atoms/icons/DeleteIcon.vue'
import dotsGrid from '@/atoms/icons/DotsGridIcon.vue'
import phoneCall from '@/atoms/icons/PhoneCallIcon.vue'
import phone from '@/atoms/icons/PhoneIcon.vue'
import copy from '@/atoms/icons/CopyIcon.vue'
import share from '@/atoms/icons/ShareIcon.vue'
import video from '@/atoms/icons/VideoIcon.vue'
import alertTriangle from '@/atoms/icons/AlertTriangleIcon.vue'
import infoCircle from '@/atoms/icons/InfoCircleIcon.vue'
import moreValues from '@/atoms/MoreValuesIcon.vue'

const customIconsToComponent: Record<string, Component | string> = {
  radioCheckedIcon,
  clear20,
  upload,
  patientList,
  tableRows,
  deleteIcon,
  dotsGrid,
  phoneCall,
  phone,
  copy,
  video,
  share,
  alertTriangle,
  infoCircle,
  moreValues
}

const customIcons: IconSet = {
  component: (props: IconProps) =>
    typeof props.icon === 'string' ? h(customIconsToComponent[props.icon]) : null
}

export { customIcons }
